/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../../services/vehicle/vehicle_interfaces.ts"/>

module DealerwareWebComponents {
    "use strict";

    import IDealerwareVehicleFactory = DealerwareWebServices.IDealerwareVehicleFactory;

    export class VehicleStatusFormDirectiveController {
        public static $inject: string[] = [
            '$timeout',
            '$scope',
            '$state',
            '$mdDialog',
            '$dealerwareVehicleFactory',
            'CurrentUser',
            '$dealerwareLoading',
            '$dealerwareNotification',
            '$dealerwareInternationalizationData',
            'i18nService',
            '$filter',
        ];

        public vehicle: any;
        public currentState: any;
        public newStatus: any;
        public loader: any;
        public labels: {};

        constructor(public $timeout: any,
                    public $scope: any,
                    public $state: any,
                    public $mdDialog: any,
                    public $dealerwareVehicleFactory: any,
                    public CurrentUser: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any,
                    public $dealerwareInternationalizationData: any,
                    public i18nService: any,
                    public $filter: any) {
            if (!this.vehicle) {
                this.vehicle = this.$dealerwareVehicleFactory.getInstance();
            }
            this.getLabels('vehicles');
            this.newStatus = [];
        }

        public getLabels(module: string) : void {
            var _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        public get currentVehicleState() : string {
            if (this.vehicle.vehicleDetails) {
                return (this.labels && this.labels.navItems) ? this.labels.navItems.vehicles.currentStatus[this.vehicle.vehicleDetails.data.current_state] : '';
            }
        }

        public resetForm() : void {
            var _self = this;

            this.vehicle.loadVehicleDetails().then(
                function(response: any) {
                    _self.$scope.vehicleStatusForm.$setPristine();
                    if (_self.loader) {
                        _self.loader.close();
                    }
                }
            );
        }

        public loadVehicleStates() : void {
            var _self = this;

            this.vehicle.loadVehicleStates().then(
                function(res: any) {
                    _self.setLabelsForStatus();
                },
                function(response: any) {
                    _self.$dealerwareNotification.apiError(response);
                }
            );
        }

        public confirmAndSave() : void {
            var _self = this;

            if (this.vehicle.vehicleDetails.data.current_state === 'dispose') {
                _self.$mdDialog.show(_self.$mdDialog.confirm()
                  .title('Dispose this vehicle?')
                  .textContent('This action will remove this vehicle from all pending reservations.')
                  .ariaLabel('confirm disposal')
                  .ok('DISPOSE VEHICLE')
                  .cancel('GO BACK')
                ).then(
                  () => { _self.saveVehicleState(); },
                  () => { _self.resetForm(); }
                );
            } else {
                _self.saveVehicleState();
            }
        }

        public saveVehicleState() : void {
            var _self = this;

            this.loader = this.$dealerwareLoading.show('Saving...');
            this.vehicle.vehicleDetails.$updateVehicleState({
                promise: true,
                params: { new_state: this.vehicle.vehicleDetails.data.current_state }
            }).then(
              function() {
                  _self.resetForm();
                  _self.$dealerwareNotification.toast('Vehicle status saved!');
              },
              function(response: any) {
                  _self.loader.close();
                  _self.$dealerwareNotification.apiError(response);
              }
            );
        }

        public setLocation(location: any) : void {
            this.vehicle.vehicleDetails.data.new_location_id = location.data.id;
        }

        public setLabelsForStatus(){
            this.newStatus.splice(0, this.newStatus.length);
            var _self = this;
            this.vehicle.vehicleStates.data.map(vehicle => {
                var status = {
                    state: vehicle.state,
                    translatedLabel: _self.formatByLanguage(_self.labels.navItems.vehicles[vehicle.state])
                }
                _self.newStatus.push(status)
            });

        }

        public formatByLanguage(label:string): string {
            const language = localStorage.getItem('language');

            if(language === 'fr') {
                return label[0].toUpperCase() + label.slice(1);
            } else{
                return this.$filter('titlecase')(label);
            }
        }

        public saveVehicleStatus() : void {
            var _self = this,
                vehicleData = this.vehicle.vehicleDetails.data,
                redirectAfterSave = vehicleData.new_location_id !== vehicleData.location_id;

            this.loader = this.$dealerwareLoading.show('Saving...');
            this.vehicle.vehicleDetails.$saveVehicleStatus({ promise: true }).then(
                function() {
                    if (redirectAfterSave) {
                        _self.loader.close();
                        _self.$state.go('shortcuts.vehiclesDashboard');
                    } else {
                        _self.resetForm();
                        _self.$dealerwareNotification.toast('Vehicle saved!');
                    }
                },
                function(response: any) {
                    _self.loader.close();
                    _self.$dealerwareNotification.apiError(response);
                }
            );
        }
    }

    getDealerwareWebComponentsModule().controller('VehicleStatusFormDirectiveController', VehicleStatusFormDirectiveController);

    export class VehicleStatusDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'VehicleStatusFormDirectiveController';
        public controllerAs     : string    =   'vehicleStatusController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {vehicle: '='};
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/vehicle/status/vehicle_status_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {
        }

    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareVehicleStatus",() => new VehicleStatusDirective());
 }
